interface PerformableTask {
  perform(): Promise<unknown>;
}

/**
 * Runs a lenient save task, then rethrows its recorded failure so submission cannot transition with
 * stale persisted totals.
 * @throws the error returned by getSaveError after the task completes
 */
export async function performGuardedSave(
  saveTask: PerformableTask,
  getSaveError: () => unknown
): Promise<void> {
  await saveTask.perform();
  const error = getSaveError();
  if (error) {
    throw error;
  }
}
